import AmazonSCImage from '../assets/amazon_small.png';
import AmazonVCImage from '../assets/amazon_small.png';
import FaireRoundImage from '../assets/faire_round.png';
import KeHERoundImage from '../assets/kehe_round.jpeg';
import CostcoRoundImage from '../assets/costco_round.jpg';
import SPINSRoundImage from '../assets/spins_round.png';
import KrogerRoundImage from '../assets/kroger_round.png';
import TargetRoundImage from '../assets/target_round.png';
import UNFIRoundImage from '../assets/unfi_round.png';
import WalmartRoundImage from '../assets/walmart_round.png';
import WegmansRoundImage from '../assets/wegmans_round.png';
import WholeFoodsRoundImage from '../assets/whole_foods.png';
import VIPLogoRound from '../assets/vip-logo-round.png';
import ShopifyLogoRound from '../assets/shopify_round.svg';
import ThriveRoundLogo from '../assets/thrive_round.jpg';
import DorasRoundLogo from '../assets/doras.png';
import BJsWholeSaleClubLogo from '../assets/bjs_whole_sale_club.png';
import InstacartRoundLogo from '../assets/instacart_round.png';
import RainforestRoundLogo from '../assets/rainforest_round.png';
import HEBRoundLogo from '../assets/heb_round.png';
import MeijerLogo from '../assets/Meijer_logo.png';
import SevenElevenLogo from '../assets/7-Eleven_logo.png';
import NIQLogo from '../assets/NIQ_logo.png';
import SamsLogo from '../assets/sams_club_logo.png';
import AlbertsonsLogo from '../assets/abscos_logo.png';
import EncompassLogo from '../assets/dsd_link_logo.png';
import HyVeeLogo from '../assets/Hy-Vee-Logo.png';
import HarrisTeeterLogo from '../assets/Harris-Teeter-Logo.png';
import DOTLogo from '../assets/dot_round.png';
import SephoraLogo from '../assets/sephora_logo.png';
import McLaneLogo from '../assets/mclane_logo.jpeg';
import iHerbLogo from '../assets/iherb_logo.jpg';
import WalgreensLogo from '../assets/walgreens_logo.png';
import CVSLogo from '../assets/cvs_logo.webp';
import SobeysLogo from '../assets/sobeys_logo.png';
import LoblawsLogo from '../assets/loblaws_logo.png';
import MetroLogo from '../assets/metro_logo.png';
import AWGLogo from '../assets/awg_logo.jpeg';
import FreshThymeRoundLogo from '../assets/fresh_thyme_logo.jpeg';
import SaveOnFoodsLogo from '../assets/save_on_foods_logo.png';
import AholdLogo from '../assets/ahold_logo.png';
import {
  getEnrichedConnections,
  getEnrichedConnectionv3,
} from '../libs/fetch.js';

const integrationTypes = (type) => {
  switch (type) {
    case 'hg':
      return {
        tabs: [
          { id: 'status', name: 'Status' },
          { id: 'products', name: 'Products' },
          { id: 'hotglue', name: 'Setup' },
        ],
        setupTab: 'hotglue',
        defaultTab: 'status',
        getEnrichedConnection: getEnrichedConnectionv3,
      };
    case 'manual':
      return {
        tabs: [
          { id: 'status', name: 'Status' },
          { id: 'upload', name: 'Uploads' },
          { id: 'products', name: 'Products' },
        ],
        setupTab: 'upload',
        defaultTab: 'upload',
        getEnrichedConnection: getEnrichedConnectionv3,
      };
    case 'pso':
      return {
        tabs: [
          { id: 'status', name: 'Status' },
          { id: 'products', name: 'Products' },
          { id: 'onboarding', name: 'Setup' },
        ],
        setupTab: 'onboarding',
        defaultTab: 'status',
        getEnrichedConnection: getEnrichedConnectionv3,
      };
  }
};

const integrationsMeta = [
  {
    name: 'Amazon Seller Central',
    title: 'Online Sales',
    imageUrl: AmazonSCImage,
    integration_id: 11,
    credentialType: 'hotglue',
    onboardingExtras: {
      tap: 'amazon-seller',
      flow_id: 'ulFC5LfQ3',
      uri: 'https://sellercentral.amazon.com',
    },
    frontendType: 'hg',
  },
  {
    name: 'Amazon Vendor Central',
    title: 'Online Sales, POs, DC Inventory, & Forecasts',
    imageUrl: AmazonVCImage,
    integration_id: 17,
    credentialType: 'hotglue',
    onboardingExtras: {
      tap: 'amazon-vendor-central',
      flow_id: 'GDHPISat0',
      uri: 'https://vendorcentral.amazon.com',
    },
    frontendType: 'hg',
  },
  {
    name: 'Costco (Circana)',
    title: 'Scans & Inventory',
    imageUrl: CostcoRoundImage,
    integration_id: 15,
    frontendType: 'pso',
  },
  {
    name: 'Faire',
    title: 'Online Sales',
    imageUrl: FaireRoundImage,
    integration_id: 8,
    credentialType: 'hotglue',
    onboardingExtras: { tap: 'faire:oauth', flow_id: 'uO8ypkFme' },
    frontendType: 'hg',
  },
  {
    name: 'KeHE Connect',
    title: 'Shipments & DC Inventory',
    imageUrl: KeHERoundImage,
    integration_id: 2,
    frontendType: 'pso',
  },
  {
    name: 'Kroger Market6',
    title: 'Scans & Inventory',
    imageUrl: KrogerRoundImage,
    integration_id: 7,
    frontendType: 'pso',
  },
  {
    name: 'SPINS Store Insights',
    title: 'Scans',
    imageUrl: SPINSRoundImage,
    integration_id: 19,
    frontendType: 'manual',
  },
  {
    name: 'Target',
    title: 'Scans & Inventory',
    imageUrl: TargetRoundImage,
    integration_id: 5,
    frontendType: 'pso',
  },
  {
    name: 'Walmart US (Scintilla Basic)',
    title: 'Scans & Inventory',
    imageUrl: WalmartRoundImage,
    integration_id: 6,
    frontendType: 'pso',
  },
  {
    name: 'Wegmans',
    title: 'Scans',
    imageUrl: WegmansRoundImage,
    integration_id: 1,
    frontendType: 'pso',
  },
  {
    name: "BJ's Wholesale Club",
    title: 'Scans & Inventory',
    integration_id: 22,
    imageUrl: BJsWholeSaleClubLogo,
    frontendType: 'pso',
  },
  {
    name: 'Whole Foods',
    title: 'Scans',
    imageUrl: WholeFoodsRoundImage,
    integration_id: 23,
    frontendType: 'pso',
  },
  {
    name: 'UNFI Insights (US)',
    title: 'Shipments & DC Inventory',
    integration_id: 25,
    imageUrl: UNFIRoundImage,
    frontendType: 'pso',
  },
  {
    name: 'UNFI SIS/Clearvue (Legacy)',
    title: 'Shipments & DC Inventory',
    integration_id: 4,
    imageUrl: UNFIRoundImage,
    frontendType: 'pso',
  },
  {
    name: 'VIP',
    title: 'Shipments & DC Inventory',
    integration_id: 26,
    imageUrl: VIPLogoRound,
    frontendType: 'pso',
  },
  {
    name: 'Shopify (Beta)',
    title: 'Online Sales',
    integration_id: 27,
    imageUrl: ShopifyLogoRound,
    frontendType: 'hg',
    onboardingExtras: {
      tap: 'shopify-v2',
      flow_id: '6DNuIuoPB',
    },
    // frontendType: 'custom',
    // customFrontend: {
    //   tabs: [
    //     { id: 'status', name: 'Status' },
    //     { id: 'products', name: 'Products' },
    //     { id: 'customSetup', name: 'Setup' },
    //   ],
    //   setupTab: 'customSetup',
    //   defaultTab: 'status',
    //   getEnrichedConnection: getEnrichedConnectionv3,
    //   customSetupTab: ShopifyCustomSetup,
    // }
  },
  {
    name: 'Thrive',
    title: 'Online Sales',
    integration_id: 20,
    imageUrl: ThriveRoundLogo,
    frontendType: 'pso',
  },
  {
    name: "Dora's Naturals",
    title: 'Shipments',
    integration_id: 30,
    imageUrl: DorasRoundLogo,
    frontendType: 'manual',
  },
  {
    name: 'Instacart Ads',
    title: 'Online Sales (Aggregated)',
    integration_id: 28,
    imageUrl: InstacartRoundLogo,
    frontendType: 'pso',
  },
  {
    name: 'Rainforest Distribution',
    title: 'Shipments',
    integration_id: 35,
    imageUrl: RainforestRoundLogo,
    frontendType: 'manual',
  },
  {
    name: "Sam's Club (Circana)",
    title: 'Scans & Inventory',
    integration_id: 38,
    imageUrl: SamsLogo,
    frontendType: 'pso',
  },
  {
    name: 'H-E-B (Circana)',
    title: 'Scans',
    integration_id: 39,
    imageUrl: HEBRoundLogo,
    frontendType: 'pso',
  },
  {
    name: 'Meijer VendorNet',
    title: 'Scans & Inventory',
    integration_id: 40,
    imageUrl: MeijerLogo,
    frontendType: 'pso',
  },
  {
    name: '7-Eleven (Circana)',
    title: 'Scans & Inventory',
    integration_id: 42,
    imageUrl: SevenElevenLogo,
    frontendType: 'pso',
  },
  {
    name: 'Nielsen TDLinx',
    title: 'Scans & Inventory',
    integration_id: 44,
    imageUrl: NIQLogo,
    frontendType: 'manual',
  },
  {
    name: 'Albertsons',
    title: 'Weekly Store Sales',
    integration_id: 45,
    imageUrl: AlbertsonsLogo,
    frontendType: 'pso',
  },
  {
    name: 'Encompass dsdlink',
    title: 'Distributor Shipments and Inventory',
    integration_id: 46,
    imageUrl: EncompassLogo,
    frontendType: 'pso',
  },
  {
    name: 'Costco Canada (Circana)',
    title: 'Scans & Inventory',
    integration_id: 49,
    imageUrl: CostcoRoundImage,
    frontendType: 'pso',
  },
  {
    name: 'Hy-Vee (Circana)',
    title: 'Scans & Inventory',
    integration_id: 50,
    imageUrl: HyVeeLogo,
    frontendType: 'pso',
  },
  {
    name: 'Harris Teeter (Circana)',
    title: 'Scans & Inventory',
    integration_id: 51,
    imageUrl: HarrisTeeterLogo,
    frontendType: 'pso',
  },
  {
    name: 'DOT Foods',
    title: 'Shipments & Inventory',
    integration_id: 10,
    imageUrl: DOTLogo,
    frontendType: 'pso',
  },
  // {
  //   name: 'McLane',
  //   title: 'Shipments & Inventory',
  //   integration_id: 53,
  //   imageUrl: McLaneLogo,
  //   frontendType: 'pso',
  // },
  {
    name: 'Costco Mexico (Circana)',
    title: 'Shipments & Inventory',
    integration_id: 55,
    imageUrl: CostcoRoundImage,
    frontendType: 'pso',
  },
  {
    name: 'Sephora (Beta)',
    title: 'Scans & Inventory',
    integration_id: 56,
    imageUrl: SephoraLogo,
    frontendType: 'pso',
  },
  {
    name: 'iHerb (Beta)',
    title: 'Online Sales',
    integration_id: 57,
    imageUrl: iHerbLogo,
    frontendType: 'pso',
  },
  {
    name: 'Walgreens (Circana)',
    title: 'Scans & Inventory',
    integration_id: 58,
    imageUrl: WalgreensLogo,
    frontendType: 'pso',
  },
  {
    name: 'CVS (Circana)',
    title: 'Scans & Inventory',
    integration_id: 59,
    imageUrl: CVSLogo,
    frontendType: 'pso',
  },
  {
    name: 'Sobeys (Circana)',
    title: 'Scans & Inventory',
    integration_id: 62,
    imageUrl: SobeysLogo,
    frontendType: 'pso',
  },
  {
    name: 'Loblaws',
    title: 'Scans & Inventory',
    integration_id: 64,
    imageUrl: LoblawsLogo,
    frontendType: 'pso',
  },
  {
    name: 'Metro (Dunnhumby)',
    title: 'Scans & Inventory',
    integration_id: 65,
    imageUrl: MetroLogo,
    frontendType: 'pso',
  },
  {
    name: 'UNFI Insights (Canada)',
    title: 'Shipments & Inventory',
    integration_id: 66,
    imageUrl: UNFIRoundImage,
    frontendType: 'pso',
  },
  {
    name: 'AWG (Circana)',
    title: 'Scans',
    integration_id: 67,
    imageUrl: AWGLogo,
    frontendType: 'pso',
  },
  {
    name: 'Walmart US (Scintilla Charter)',
    title: 'Scans & Inventory',
    imageUrl: WalmartRoundImage,
    integration_id: 70,
    frontendType: 'pso',
  },
  {
    name: 'Walmart Canada (Scintilla Charter)',
    title: 'Scans & Inventory',
    imageUrl: WalmartRoundImage,
    integration_id: 74,
    frontendType: 'pso',
  },
  {
    name: 'Walmart Mexico (Scintilla Charter)',
    title: 'Scans & Inventory',
    imageUrl: WalmartRoundImage,
    integration_id: 74,
    frontendType: 'pso',
  },
  {
    name: 'Harris Teeter (Vendor Portal)',
    title: 'Scans & Inventory',
    imageUrl: HarrisTeeterLogo,
    integration_id: 71,
    frontendType: 'pso',
  },
  {
    name: 'H-E-B (Supplier Portal)',
    title: 'DC Inventory',
    imageUrl: HEBRoundLogo,
    integration_id: 72,
    frontendType: 'pso',
  },
  {
    name: 'Fresh Thyme Market',
    title: 'Scans',
    imageUrl: FreshThymeRoundLogo,
    integration_id: 73,
    frontendType: 'pso',
  },
  {
    name: 'Save-On-Foods (Circana)',
    title: 'Scans',
    imageUrl: SaveOnFoodsLogo,
    integration_id: 76,
    frontendType: 'pso',
  },
  {
    name: 'Ahold (Circana)',
    title: 'Scans',
    imageUrl: AholdLogo,
    integration_id: 77,
    frontendType: 'pso',
  },
];

const getIntegration = (id) => {
  if (!id) return null;
  if (typeof id === 'string') id = Number(id);
  if (isNaN(id)) return null;
  if (id < 0) return null;
  const int = integrationsMeta.find((i) => i.integration_id === id);
  if (!int) return null;
  if (int.frontendType === 'custom') {
    return { ...int, ...int.customFrontend };
  }
  const intTypeExtra = integrationTypes(int.frontendType);
  return { ...int, ...intTypeExtra };
};

const integrationIds = integrationsMeta.map((i) => i.integration_id);

const getEnrichedIntegrations = async (currentOrganization) => {
  const { available, unavailable } = (await getEnrichedConnections(currentOrganization)) || [];
  return {
    'available': available?.map((connection) => {
      const integration = getIntegration(connection.integration_id);
      if (integration) {
        return {...integration, ...connection, available: true}
      } else {
        return null;
      }
    }).filter((i) => i !== null),
    'unavailable': unavailable?.map((i) => getIntegration(i)).filter((i) => i != null),
  }
};

export default integrationsMeta;

export { getIntegration, integrationIds, getEnrichedIntegrations };
